export default __webpack_public_path__ + "static/media/07_uncle.a87f384a.png";